import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Edit your video`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/602eec83f59aeca30bffb010cd549955/SX_VideoCrop_44_N.svg",
                "alt": "Crop Video"
              }}></img><p>{`Crop video`}</p></div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/5adad34a02a35f4d857d5197780cd67b/SX_VideoResize_44_N.svg",
                "alt": "Resize Video"
              }}></img><p>{`Resize video`}</p></div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/2e7830f5062c2f6fea7b8d19087cb24d/trim.svg",
                "alt": "Trim Video"
              }}></img><p>{`Trim video`}</p></div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/a1246dceddef66cefc108d37402cbc83/SX_VideoMerge_44_N.svg",
                "alt": "Merge Videos"
              }}></img><p>{`Merge videos`}</p></div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/7f82f86467d35ccc4c3ea44272547119/SX_ConvertVideo_44_N.svg",
                "alt": "Convert to GIF"
              }}></img><p>{`Convert to GIF`}</p></div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/7f82f86467d35ccc4c3ea44272547119/SX_ConvertVideo_44_N.svg",
                "alt": "Convert to MP4"
              }}></img><p>{`Convert to MP4`}</p></div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/6ec73fc1959d9d1be4b922ae86340480/SX_AnimateCaracter_44_N.svg",
                "alt": "Animate from audio"
              }}></img><p>{`Convert to GIF`}</p></div></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><div><img parentName="td" {...{
                "src": "/express/embed-sdk/assets/40f54c8b2519a2fe38571802d8430f52/SX_VideoCaption_44_N.svg",
                "alt": "Caption video"
              }}></img><p>{`Convert to MP4`}</p></div></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      